import { ErrorType } from 'components/Error';
import Cookies from 'js-cookie';
import type { GetServerSidePropsContext } from 'next';
import cookies from 'next-cookies';

const _fetch = async (
    url: string,
    context?: GetServerSidePropsContext,
    config: RequestInit = {}
): Promise<Response> => {
    let token;
    if (context) token = cookies(context)?.token;
    else token = Cookies.get('token');

    const construcctUrl = () => {
        if (url.substring(0, 4) === 'http') return url;
        return process.env.NEXT_PUBLIC_API_HOST + url;
    };

    return fetch(construcctUrl(), {
        ...config,
        headers: {
            ...(config?.headers || {}),
            Authorization: 'Bearer ' + token,
            ['X-Requested-With']: 'XMLHttpRequest'
        }
    });
};

export interface HandleFetchReturn {
    error?: ErrorType;
}

const handleFetch = async (res: Response, mapping: (responseData: any) => any = () => ({ props: {} })) => {
    switch (res.status) {
        case 200:
            return mapping(await res.json());

        case 401:
            return {
                redirect: { destination: '/', permanent: false }
            };

        case 404:
            return {
                notFound: true
            };

        case 503:
            return {
                redirect: { destination: '/maintenance', permanent: false }
            };

        default:
            return {
                props: {
                    error: { ...(await res.json()), code: res.status }
                }
            };
    }
};

export { _fetch as fetch, handleFetch };
